var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2167 0.987644C14.9609 0.770669 14.559 0.739624 14.1435 0.906449H14.1428C13.7058 1.0818 1.77211 6.20052 1.2863 6.40965C1.19794 6.44035 0.426245 6.72829 0.505734 7.36966C0.576695 7.94792 1.19692 8.18741 1.27265 8.21505L4.30656 9.25387C4.50784 9.9239 5.24986 12.3959 5.41395 12.924C5.5163 13.2532 5.68313 13.6858 5.9755 13.7749C6.23205 13.8738 6.48723 13.7834 6.65235 13.6538L8.50722 11.9333L11.5016 14.2685L11.5729 14.3112C11.7762 14.4012 11.971 14.4463 12.1569 14.4463C12.3005 14.4463 12.4384 14.4193 12.5701 14.3654C13.0187 14.1812 13.1981 13.7537 13.2169 13.7053L15.4535 2.07969C15.59 1.45878 15.4003 1.14287 15.2167 0.987644ZM6.98225 9.6694L5.95878 12.3986L4.93531 8.98708L12.7819 3.18742L6.98225 9.6694Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic-telegram.62cc7c38dadc0eca20b1de6f90bab9c3.svg";
export { ForwardRef as ReactComponent };